import Authorization from "../components/auth/authorization";
import { UserPermission } from "../constants/permissions.constants";
import { useContainerStyles } from "../@styles/container.styles";
import ContinuumScannerLicenseList from "../components/continuum-scanner-license/continuum-scanner-license-list";
import { useStyles } from "./all-continuum-scanner-licenses.styles";

const AllContinuumScannerLicensesPage = () => {
  const contClasses = useContainerStyles();
  const classes = useStyles();
  return (
    <Authorization>
      <section
        key={UserPermission.P_CONTINUUM_SCANNER_LICENSE}
        className={contClasses.sectionContainer}
      >
        <div
          className={
            "dashboard-tile " + contClasses.boxContainer + " " + classes.box
          }
        >
          <div className={contClasses.root}>
            <div style={{ marginTop: "3rem" }}>
              <ContinuumScannerLicenseList />
            </div>
          </div>
        </div>
      </section>
    </Authorization>
  );
};

export default AllContinuumScannerLicensesPage;
